/* eslint-disable camelcase */
import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"

import { decodeHtmlCharacters, pdpTypeFormat } from "@/utils/helper"
import {
  accordianAnalyticsData,
  getEventInfoProdAccordion,
} from "@/components/ProductDetail/v3/ProductAccordionList/analytics"
import { getCountryList } from "@/store/features/genericSlice"

import DesignFiles from "@/components/ProductDetail/v3/ProductAccordionList/designFiles"
import InstallationSupport from "@/components/ProductDetail/v3/ProductAccordionList/installationSupport"
import AddanInstallation from "@/components/ProductDetail/v3/AddanInstallation"
import DesignServices from "@/components/ProductDetail/v3/DesignServices"
import ProductAccordion from "@/components/ProductDetail/v3/ProductAccordionList/productAccordion"
import AdditionalInfo from "@/components/ProductDetail/v3/ProductAccordionList/AdditionalInfo"
import Policies from "@/components/ProductDetail/v3/ProductAccordionList/Policies"
import Button from "@/components/core/Button/Button"

import downloadIcon from "@/public/icons/download-dark-gray.svg"
import accordionStyles from "@/components/core/Accordion/Accordion.module.scss"
import styles from "@/components/ProductDetail/v3/ProductAccordionList/index.module.scss"

const ProductAccordionList = props => {
  const {
    width = 0,
    config = {},
    productData = {},
    productSku = "",
    productInfo = {},
    isDiscontinued = false,
    persona = "",
    staticTexts = {},
    accordionList = [],
    installationDataFromProp = [],
    designServiceDataFromProp = [],
    disableEcommerce = false,
    isProjectPack = false,
    currencySign = "",
    businessUnitName = "",
    ProductPriceSpiderIncluded_s = "",
    discontinuedProductb = "",
    ProductRequiredAccessoriesGroupsList = [],
    superSku = "",
    designServiceData = [],
    currencyCode = "",
    locale = "",
    replaceAddToCart = () => {},
    disableRatings = false,
    replaceAddToCartCtaLink = () => {},
    replaceAddToCartCtaLabel = () => {},
    linkNewTab = false,
    getZipCode = () => {},
    installationData = [],
    installationSupportLinks = [],
    productType = "",
    productServices = [],
    bundleItems = [],
    bundleAdditionalFeatures = [],
    isSSr=false
  } = props

  const { productAccordionText = {} } = staticTexts
  const defaultExpand = {
    feature: true,
    specs: false,
    designFile: false,
    installationSupport: false,
    addOnService: false,
    additionalInfo: false,
    policies: false,
    additionalBundleFeatures: false,
  }
  const designFiles = {
    twoDimension: {
      plan: [],
      front: [],
      side: [],
    },
    threeDimension: [],
    bim: [],
    cutout: [],
  }
  const techFiles = []
  const installFiles = {
    productId: productData["ProductProductNo_s"] ?? "",
    guides: {
      installationGuides: [],
      supportGuides: [],
    },
    partsLinks: [],
    pdfPartsLinks: [],
    videos: [],
    supportLinks: [],
  }
  const designFileType = {
    twoDimension: [
      { type: "DWG", fromProductData: "DWGPlanView", angleView: "plan" },
      { type: "DXF", fromProductData: "DXFPlanView", angleView: "plan" },
      { type: "DWG", fromProductData: "DWGFrontView", angleView: "front" },
      { type: "DXF", fromProductData: "DXFFrontView", angleView: "front" },
      { type: "DWG", fromProductData: "DWGSideView", angleView: "side" },
      { type: "DXF", fromProductData: "DXFSideView", angleView: "side" },
    ],
    threeDimension: [
      { type: "DWG", fromProductData: "3DDWGSymbol" },
      { type: "DXF", fromProductData: "3DDXFSymbol" },
      { type: "3DS", fromProductData: "3D3DS" },
      { type: "OBJ", fromProductData: "3DOBJ" },
      { type: "SKP", fromProductData: "3DSketchup" },
    ],
    bim: [{ type: "RFA", fromProductData: "3DRevit" }],
    cutout: [{ type: "DXF", fromProductData: "CutOutDXF" }],
  }
  const [isExpanded, setIsExpanded] = useState(defaultExpand)
  const [viewMore, setViewMore] = useState({
    [productAccordionText.features]: false,
    [productAccordionText.technologies]: false,
    [productAccordionText.hydrotherapy]: false,
    [productAccordionText.material]: false,
    [productAccordionText.rebates]: false,
    [productAccordionText.installation]: false,
    [productAccordionText.props65Warning]: false,
  })
  const [currentSku, setCurrentSku] = useState(productSku)
  const [countryLists, setCountryLists] = useState([
    { text: "India", value: "IN" },
  ])
  const [count, setCount] = useState(5)

  const handleViewRemaining = () => {
    setCount(bundleItems.length)
  }
  const dispatch = useDispatch()

  const fetchCountry = async () => {
    try {
      const { payload: countryList = [] } = await dispatch(getCountryList())
      if (countryList.length) {
        setCountryLists(countryList)
      }
    } catch (error) {
      log.error(error)
    }
  }

  useEffect(() => {
    fetchCountry()
  }, [])

  useEffect(() => {
    if (productSku !== "" && currentSku !== productSku) {
      setCurrentSku(productSku)
      setTimeout(() => {
        setIsExpanded(defaultExpand)
      }, 500)
    }
  }, [productSku])
  const SetListData = ({ listData = [], showType }) => (
    <>
      <ul className="pdp-features-technologies__feature-list">
        {listData.map(
          (item, i) =>
            (i < 5 || (i > 4 && viewMore[showType])) && (
              <li key={i} className="pdp-features-technologies__list-item">
                {item.replace(/"/g, " inch")}
              </li>
            )
        )}
      </ul>
      {listData.length > 5 && !viewMore[showType] && (
        <a
          className="pdp-features-technologies__view-more gbh-data-layer"
          data-gbh-data-layer={getEventInfoProdAccordion(
            productAccordionText.viewMore
          )}
          data-gbh-data-layer-custom={productInfo}
          onClick={() => setViewMore({ ...viewMore, [showType]: true })}
        >
          {productAccordionText.viewMore}
        </a>
      )}
    </>
  )

  const handleSpecsDownload = (e, title, link) => {
    e.stopPropagation()
    if (typeof window !== "undefined") {
      let errMsg
      const url = link.trim()
      try {
        window.open(url, "_blank")
      } catch (err) {
        errMsg = err.message
      }
      const eventInfo = getEventInfoProdAccordion(title, true, url, errMsg)
      const dataLayerProductInfo = productInfo
        ? JSON.parse(productInfo)?.productInfo
        : null
      const { adobeDataLayer: { getState } = {} } = window
      const page = (getState && getState("page")) || {}
      window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo,
        productInfo: dataLayerProductInfo,
      })
    }
  }

  const organizeData = (data, name, placeHolder, type) =>
    data.map((item, i) => {
      let obj = {
        title: name
          ? name[i]
          : `${placeHolder} ${data.length > 1 ? i + 1 : ""}`,
      }
      if (type === "part") {
        obj = { ...obj, id: item }
      } else {
        obj = { ...obj, type, url: item }
      }
      return obj
    })

  Object.keys(designFileType).forEach(fileType => {
    designFileType[fileType] &&
      designFileType[fileType].forEach(file => {
        if (
          productData[
            `ProductResource.${file.fromProductData}.resourceFullWebURL_ss`
          ]
        ) {
          if (fileType === "twoDimension") {
            designFiles[fileType][file.angleView].push({
              type: file.type,
              url: productData[
                `ProductResource.${file.fromProductData}.resourceFullWebURL_ss`
              ][0],
            })
          } else {
            designFiles[fileType].push({
              type: file.type,
              url: productData[
                `ProductResource.${file.fromProductData}.resourceFullWebURL_ss`
              ][0],
            })
          }
        }
      })
  })

  const designFilesLength =
    designFiles.twoDimension.plan.length +
    designFiles.twoDimension.front.length +
    designFiles.twoDimension.side.length +
    designFiles.threeDimension.length +
    designFiles.bim.length +
    designFiles.cutout.length

  const getListValue = (arrayVal, stringVal) => {
    if (productData[arrayVal]) {
      return productData[arrayVal]
    } else if (productData[stringVal]) {
      return [productData[stringVal]]
    } else {
      return []
    }
  }

  const featuresData = getListValue(
    "ProductWebFeatures_ss",
    "ProductWebFeatures_s"
  )
  const techData = getListValue(
    "ProductWebTechnology_ss",
    "ProductWebTechnology_s"
  )
  const webmaterialData = getListValue(
    "ProductWebMaterial_ss",
    "ProductWebMaterial_s"
  )
  const webInstallationData = getListValue(
    "ProductWebInstallation_ss",
    "ProductWebInstallation_s"
  )
  const prop65WarningData = getListValue(
    "ProductCaliforniaProp65WarningDisclaimer_ss",
    "ProductCaliforniaProp65WarningDisclaimer_s"
  )
  const webRebatesData = getListValue(
    "ProductWebRebates_ss",
    "ProductWebRebates_s"
  )
  const webHydrotherapyData = getListValue(
    "ProductWebHydrotherapy_ss",
    "ProductWebHydrotherapy_s"
  )
  const badges = getListValue("ProductBadgeInfo_ss", "ProductBadgeInfo_s")
  // check for technical files
  if (productData["ProductResource.SpecPDFFileName.resourceFullWebURL_ss"]) {
    techFiles.push(
      ...organizeData(
        productData["ProductResource.SpecPDFFileName.resourceFullWebURL_ss"],
        productData["ProductResource.SpecPDFFileName.resourceTitle_ss"],
        productAccordionText.specsSheet,
        "PDF"
      )
    )
  }
  if (productData["ProductResource.EnvironProdDecl.resourceFullWebURL_ss"]) {
    techFiles.push(
      ...organizeData(
        productData["ProductResource.EnvironProdDecl.resourceFullWebURL_ss"],
        productData["ProductResource.EnvironProdDecl.resourceTitle_ss"],
        productAccordionText.envDeclaration,
        "PDF"
      )
    )
  }
  const specDataLength =
    techData.length +
    webmaterialData.length +
    webInstallationData.length +
    prop65WarningData.length +
    webRebatesData.length +
    webHydrotherapyData.length +
    techFiles.length
  const specsDetails = [
    { specTitle: productAccordionText.technologies, specList: techData },
    {
      specTitle: productAccordionText.hydrotherapy,
      specList: webHydrotherapyData,
    },
    { specTitle: productAccordionText.material, specList: webmaterialData },
    { specTitle: productAccordionText.rebates, specList: webRebatesData },
    {
      specTitle: productAccordionText.installation,
      specList: webInstallationData,
    },
    {
      specTitle: productAccordionText.props65Warning,
      specList: prop65WarningData,
    },
  ]
  const additionalInfo = [
    {
      title: productAccordionText.additionalInfo?.productCode,
      data: productSku,
    },
    {
      title: productAccordionText.additionalInfo?.countryOfOrigin,
      data: countryLists?.find(
        list => list.value === productData?.SKUCountryofOrigin_s
      )?.text,
    },
    {
      title: productAccordionText.additionalInfo?.dimensions,
      data:
        productData["ProductOverallLengthCm_d"] &&
        parseFloat(productData["ProductOverallLengthCm_d"]) > 0 &&
        `${parseFloat(productData["ProductOverallLengthCm_d"])} × ${parseFloat(
          productData["ProductOverallWidthCm_d"]
        )} × ${parseFloat(productData["ProductOverallHeightCm_d"])}`,
    },
    {
      title: productData["RegionSupplyChain_ss"],
      data: productAccordionText.additionalInfo?.importedBy,
    },
    {
      title: productAccordionText.additionalInfo?.qty,
      data: productAccordionText.additionalInfo?.oneUnit,
    },
    {
      title: productAccordionText.additionalInfo?.package,
      data: productData["ProductPackageContents_s"],
    },
    {
      title: productAccordionText.additionalInfo?.contact,
      data: productAccordionText.additionalInfo?.customerCare,
    },
    {
      title: productAccordionText.additionalInfo?.spareParts,
      data: productAccordionText.additionalInfo?.sparePartsMsg,
    },
    {
      title: productAccordionText.additionalInfo?.disclaimer,
      data: productAccordionText.additionalInfo?.disclaimerMsg,
    },
  ]

  const Features = () => (
    <div
      className="pdp-features-technologies__content"
      aria-hidden={isExpanded.feature ? "false" : "true"}
    >
      <div className="pdp-features-technologies__container">
        <SetListData
          listData={featuresData}
          showType={productAccordionText.features}
        />
        {watersense.length > 0 && (
          <div className="pdp-features-technologies__icons">
            {watersense.map((icon, i) => (
              <img key={i} src={icon} alt="watersense icon" />
            ))}
          </div>
        )}
      </div>
    </div>
  )

  const Specs = () => (
    <>
      <div className="pdp-technical-tile__files --specs-info">
        {techFiles.map((item, i) => (
          <section key={i}>
            <div
              className="pdp-technical-tile__file"
              role="link"
              tabIndex={0}
              onClick={e => handleSpecsDownload(e, item.title, item.url)}
            >
              <img alt="" aria-hidden="true" src={downloadIcon?.src} />
              {item.title}
            </div>
          </section>
        ))}
      </div>
      {specsDetails.map(
        (subCategory, i) =>
          subCategory.specList.length > 0 && (
            <div key={i} className="pdp-spec-detail__container">
              <p className="pdp-spec-detail__title">{subCategory.specTitle}</p>
              <SetListData
                listData={subCategory.specList}
                showType={subCategory.specTitle}
              />
            </div>
          )
      )}
    </>
  )
  const DesignComponent = () =>
    !isDiscontinued &&
    designServiceDataFromProp.map((list, i) => {
      const { productType: productTypes = [] } = list
      return (
        productTypes.includes(productType) && (
          <div
            key={i}
            className="row no-gutters product-detail-page__design-services"
          >
            <DesignServices
              staticTexts={staticTexts}
              currencySign={currencySign}
              pdpType={pdpTypeFormat({
                businessUnitName: businessUnitName,
                ProductPriceSpiderIncluded_s: ProductPriceSpiderIncluded_s,
                discontinuedProductb: discontinuedProductb,
                ProductRequiredAccessoriesGroupsList:
                  ProductRequiredAccessoriesGroupsList,
                superSku: superSku,
              })}
              sku={list.sku}
              designServiceAPIData={designServiceData.filter(
                item => item.masterVariant.sku === list.sku
              )}
              persona={persona}
              designServiceListData={list}
              currencyCode={currencyCode}
              locale={locale}
              width={width}
              replaceAddToCart={replaceAddToCart}
              disableRatings={disableRatings}
              replaceAddToCartCtaLink={replaceAddToCartCtaLink}
              replaceAddToCartCtaLabel={replaceAddToCartCtaLabel}
              linkNewTab={linkNewTab}
              disableEcommerce={disableEcommerce}
            />
          </div>
        )
      )
    })

  const InstallComponent = () =>
    !isDiscontinued &&
    installationDataFromProp.map((list, index) => {
      return productServices && productServices.includes(list.sku) ? (
        <AddanInstallation
          staticTexts={staticTexts}
          currencySign={currencySign}
          locale={locale}
          persona={persona}
          getZipCode={getZipCode}
          installtionAPIData={installationData.filter(
            item => item.masterVariant.sku === list.sku
          )}
          sku={list.sku}
          installationServiceData={list}
          key={index}
          currencyCode={currencyCode}
          pdpType={pdpTypeFormat({
            businessUnitName,
            ProductPriceSpiderIncluded_s,
            discontinuedProductb,
            ProductRequiredAccessoriesGroupsList,
            superSku,
          })}
          width={width}
          replaceAddToCart={replaceAddToCart}
          disableRatings={disableRatings}
          replaceAddToCartCtaLink={replaceAddToCartCtaLink}
          replaceAddToCartCtaLabel={replaceAddToCartCtaLabel}
          linkNewTab={linkNewTab}
          disableEcommerce={disableEcommerce}
        />
      ) : null
    })
  const AddOnService = props => (
    <>
      <DesignComponent
        replaceAddToCart={replaceAddToCart}
        disableRatings={disableRatings}
        replaceAddToCartCtaLink={replaceAddToCartCtaLink}
        replaceAddToCartCtaLabel={replaceAddToCartCtaLabel}
        linkNewTab={linkNewTab}
        disableEcommerce={disableEcommerce}
      />
      <InstallComponent
        replaceAddToCart={replaceAddToCart}
        disableRatings={disableRatings}
        replaceAddToCartCtaLink={replaceAddToCartCtaLink}
        replaceAddToCartCtaLabel={replaceAddToCartCtaLabel}
        linkNewTab={linkNewTab}
        disableEcommerce={disableEcommerce}
      />
    </>
  )

  // check for installation & support files
  if (
    productData[
      "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss"
    ]
  ) {
    installFiles.guides.installationGuides = organizeData(
      productData[
        "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss"
      ],
      productData["ProductResource.InstallationWithoutSPPDF.resourceTitle_ss"],
      productAccordionText.installationGuide,
      "PDF"
    )
  }
  if (productData["ProductResource.HomeownersGuide.resourceFullWebURL_ss"]) {
    installFiles.guides.supportGuides = organizeData(
      productData["ProductResource.HomeownersGuide.resourceFullWebURL_ss"],
      productData["ProductResource.HomeownersGuide.resourceTitle_ss"],
      productAccordionText.homeOwnerGuide,
      "PDF"
    )
  }
  if (productData["ProductResource.YouTubeInstallVideo.resourceName_ss"]) {
    installFiles.videos = organizeData(
      productData["ProductResource.YouTubeInstallVideo.resourceName_ss"],
      productData["ProductResource.YouTubeInstallVideo.resourceTitle_ss"],
      productAccordionText.installationVideo,
      "part"
    )
  }

  if (productData["ProductResource.InteractiveSVG.resourceName_ss"]) {
    installFiles.partsLinks = organizeData(
      productData["ProductResource.InteractiveSVG.resourceName_ss"],
      productData["ProductResource.InteractiveSVG.resourceTitle_ss"],
      productAccordionText.partsDiagram,
      "part"
    )
  }

  if (productData["ProductResource.PartsPDFFileName.resourceFullWebURL_ss"]) {
    installFiles.pdfPartsLinks = organizeData(
      productData["ProductResource.PartsPDFFileName.resourceFullWebURL_ss"],
      productData["ProductResource.PartsPDFFileName.resourceTitle_ss"],
      productAccordionText.partsDiagram,
      "part"
    )
  }
  // Get support pages links from content fragment

  installFiles.supportLinks = installationSupportLinks?.length
    ? installationSupportLinks
    : []

  const installationFilesLength =
    installFiles.guides.installationGuides.length +
    installFiles.guides.supportGuides.length +
    installFiles.partsLinks.length +
    installFiles.videos.length +
    installFiles.supportLinks.length

  let listValue = [
    "Features",
    "Specs",
    "Installation & Support",
    "Design Files",
    "Available Services",
  ]
  if (persona === "TVS" || persona === "TPR") {
    listValue = [
      "Features",
      "Specs",
      "Design Files",
      "Installation & Support",
      "Available Services",
    ]
  } else if (accordionList.length > 0) {
    listValue = accordionList.map(obj => decodeHtmlCharacters(obj?.value ?? ""))
  }
  const isInstallService = installationDataFromProp.filter(
    obj => productServices && productServices.includes(obj.sku)
  )
  const isDesignService = designServiceDataFromProp.filter(obj =>
    obj.productType.includes(productType)
  )
  const { feature, specs, designFile, installationSupport, addOnService } =
    isExpanded
  const componentList = {
    Features: {
      element: <Features />,
      title: productAccordionText.features,
      isExpanded: isExpanded.feature,
      keyValue: "feature",
      showAccordion: featuresData.length > 0,
      analyticData: accordianAnalyticsData(
        productAccordionText.features,
        isExpanded.feature
      ),
    },
    Specs: {
      element: <Specs />,
      title: productAccordionText.specs,
      isExpanded: isSSr?true: isExpanded.specs,
      keyValue: "specs",
      showAccordion: specDataLength > 0,
      analyticData: accordianAnalyticsData(
        productAccordionText.specs,
        isExpanded.specs
      ),
    },
    "Design Files": {
      element: (
        <DesignFiles
          files={designFiles}
          staticTexts={productAccordionText}
          productInfo={productInfo}
          sku={productSku}
        />
      ),
      title: productAccordionText.designFiles,
      isExpanded: isSSr?true: isExpanded.designFile,
      showAccordion: designFilesLength > 0,
      keyValue: "designFile",
      analyticData: accordianAnalyticsData(
        productAccordionText.designFiles,
        isExpanded.designFile
      ),
    },
    "Installation & Support": {
      element: (
        <InstallationSupport
          files={installFiles}
          staticTexts={productAccordionText}
          productInfo={productInfo}
          sku
          productSku
        />
      ),
      title: productAccordionText.installationSupport,
      isExpanded: isSSr?true: isExpanded.installationSupport,
      showAccordion: installationFilesLength > 0,
      keyValue: "installationSupport",
      analyticData: accordianAnalyticsData(
        productAccordionText.installationSupport,
        isExpanded.installationSupport
      ),
    },
    "Available Services": {
      element: (
        <AddOnService
          files={installFiles}
          staticTexts={productAccordionText}
          productInfo={productInfo}
          sku={productSku}
          replaceAddToCart={props.replaceAddToCart}
          disableRatings={props.disableRatings}
          replaceAddToCartCtaLink={props.replaceAddToCartCtaLink}
          replaceAddToCartCtaLabel={props.replaceAddToCartCtaLabel}
          linkNewTab={props.linkNewTab}
          disableEcommerce={props.disableEcommerce}
        />
      ),
      title: productAccordionText.addOnServices,
      isExpanded: isSSr?true: isExpanded.addOnService,
      showAccordion:
        !isDiscontinued &&
        !disableEcommerce &&
        (isInstallService.length > 0 || isDesignService.length > 0) &&
        !isProjectPack,
      keyValue: "addOnService",
      analyticData: accordianAnalyticsData(
        productAccordionText.addOnServices,
        isExpanded.addOnService
      ),
    },
    "Additional Information": {
      element: (
        <AdditionalInfo
          data={additionalInfo}
          productAccordionText={productAccordionText}
        />
      ),
      title: productAccordionText.additionalInfo?.title,
      isExpanded: isSSr?true: isExpanded.additionalInfo,
      keyValue: "additionalInformation",
      showAccordion: !bundleItems.length,
      analyticData: accordianAnalyticsData(
        productAccordionText.additionalInfo?.title,
        isExpanded.additionalInfo
      ),
    },
    "Returns & Warranty": {
      element: (
        <Policies staticTexts={productAccordionText.policies} config={config} />
      ),
      title: productAccordionText.policies?.title,
      isExpanded: isSSr?true: isExpanded.policies,
      keyValue: "policies",
      showAccordion: true,
      analyticData: accordianAnalyticsData(
        productAccordionText.policies?.title,
        isExpanded.policies
      ),
    },
  }

  const watersense = badges.map((badge = "") => {
    const watersenseList = badge.split("|")
    return watersenseList[2] || []
  })

  const setAccordianState = (type, isOpen) => {
    if (!isOpen) {
      setTimeout(() => {
        setIsExpanded({ ...isExpanded, [type]: isOpen })
      }, 500)
    } else {
      setIsExpanded({ ...isExpanded, [type]: isOpen })
    }
  }

  return (
    <div
      className={`${accordionStyles.accordionWrapper} ${styles.productAccordionListWrapper}`}
    >
      {Object.keys(productData).length > 0 && (
        <div className={`pdp-support-files__container product-specifications`}>
          {bundleAdditionalFeatures.length > 0 &&
            bundleAdditionalFeatures.map((item, index) => (
              <ProductAccordion
                title={item?.title}
                key={index}
                isOpen={false}
                showOnPrint={false}
                handleOpen={() => setAccordianState(item.title, true)}
                handleClose={() => setAccordianState(item.title, false)}
              >
                <ul className="pdp-features-technologies__feature-list">
                  {item.descriptions.map((element, index) => (
                    <li
                      key={index}
                      className="pdp-features-technologies__list-item"
                    >
                      {element}
                    </li>
                  ))}
                </ul>
              </ProductAccordion>
            ))}
          {listValue.map(list =>
            componentList[list]?.showAccordion ? (
              <ProductAccordion
                title={componentList[list].title}
                key={componentList[list].keyValue}
                isOpen={componentList[list]?.isExpanded}
                showOnPrint={list === "Features" || list === "Specs"}
                handleOpen={() =>
                  setAccordianState(componentList[list].keyValue, true)
                }
                handleClose={() =>
                  setAccordianState(componentList[list].keyValue, false)
                }
                analyticTitleData={componentList[list].analyticData}
                analyticTitleCustomData={productInfo}
              >
                {componentList[list].element}
              </ProductAccordion>
            ) : null
          )}
          {bundleItems.slice(0, count).map(item => (
            <ProductAccordion
              title={
                productAccordionText.additionalInfo?.title + ` - ${item.sku}`
              }
              key={item.sku}
              isOpen={false}
              showOnPrint={false}
              handleOpen={() => setAccordianState(item.sku, true)}
              handleClose={() => setAccordianState(item.sku, false)}
              analyticTitleData={accordianAnalyticsData(
                productAccordionText.additionalInfo?.title + ` - ${item.sku}`,
                isExpanded[item.sku]
              )}
              analyticTitleCustomData={productInfo}
            >
              <AdditionalInfo
                data={[
                  {
                    title: productAccordionText.additionalInfo?.productCode,
                    data: item.sku,
                  },
                  {
                    title: productAccordionText.additionalInfo?.countryOfOrigin,
                    data: countryLists?.find(
                      list => list.value === item.additionalInfo?.country
                    )?.text,
                  },
                  {
                    title: productAccordionText.additionalInfo?.dimensions,
                    data:
                      item.additionalInfo?.length &&
                      parseFloat(item.additionalInfo?.length) > 0 &&
                      `${parseFloat(
                        item.additionalInfo?.length
                      )} × ${parseFloat(
                        item.additionalInfo?.width
                      )} × ${parseFloat(item.additionalInfo?.height)}`,
                  },
                  {
                    title: item.additionalInfo?.regionSupplyChain,
                    data: productAccordionText.additionalInfo?.importedBy,
                  },
                  {
                    title: productAccordionText.additionalInfo?.qty,
                    data: productAccordionText.additionalInfo?.oneUnit,
                  },
                  {
                    title: productAccordionText.additionalInfo?.package,
                    data: item.additionalInfo?.packageContent,
                  },
                  {
                    title: productAccordionText.additionalInfo?.contact,
                    data: productAccordionText.additionalInfo?.customerCare,
                  },
                  {
                    title: productAccordionText.additionalInfo?.spareParts,
                    data: productAccordionText.additionalInfo?.sparePartsMsg,
                  },
                  {
                    title: productAccordionText.additionalInfo?.disclaimer,
                    data: productAccordionText.additionalInfo?.disclaimerMsg,
                  },
                ]}
                productAccordionText={productAccordionText}
              />
            </ProductAccordion>
          ))}
          {bundleItems.length > 5 && count === 5 && (
            <Button
              label={`${staticTexts?.viewRemaining} (${
                bundleItems.length - 5
              })`}
              onClick={handleViewRemaining}
              flexible
              size="small"
              type="ghost"
              role="button"
              customClass="bundle-additional-info"
            />
          )}
        </div>
      )}
    </div>
  )
  //   }
}

export default ProductAccordionList
